
import {filter} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { SuitabilityAction } from '@toro/common/shared/state-management/suitability/suitability.action';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { CampaignNameEnum } from '@hub-workspace/apps/logged-home/src/app/shared/enums/campaign-name.enum';
import { environment } from '@hub-workspace/apps/logged-home/src/environments/environment';

@Component({
    selector: 'trader-bar-card',
    templateUrl: './trader-bar-card.component.html',
    styleUrls: ['./trader-bar-card.component.scss']
})
export class TraderBarCardComponent implements OnInit {
    public campaignName: string;
    public userPending: boolean = true;
    public campaignNameEnum = CampaignNameEnum;
    public isNewBrand: boolean = environment.isNewBrand

    constructor(
        protected store: Store<AppState>,
        private router: Router
    ) {
        this.store.dispatch({ type: SuitabilityAction.getProfile });
    }

    ngOnInit() {
        this.getUserProfile();
    }

    // Recupera os dados do perfil do usuário
    public getUserProfile() {
        this.store.select((state) => state.userProfile.user).pipe(
        filter((user: any) => user && !user.pending))
        .subscribe((user) => {
            if(user.campaignName) {
                this.campaignName = user.campaignName;
            }
            this.userPending = false;
        });
    }

    public isVisibleBanner(bannerCampaign: string) {
        return this.campaignName == bannerCampaign;
    }

    public redirect(url: string, element: string, group: string) {
        this.sendTracking("Element Clicked", {
            'Product Area Origin': "Home Trader",
            'Time Responsável': "Brooklyn Dumbo",
            'Group': group,
            Element: element,
        });
        this.router.navigateByUrl(url);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
          type: TrackingActions.trackEvents,
          payload: { type: event, events: breakdowns },
        });
      }
}
